import React from 'react';
import classNames from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';
import { SignUpButton } from '../../../components/SignUpButton';

export interface PlaylistsSharingFeature {
  label: React.ReactNode;
  icon: IconDefinition;
}

export interface PlaylistsSharingPremiumPricingElementProps {
  label?: string;
  title: string;
  price: string;
  subtitle: React.ReactNode | string;
  outline?: boolean;
  listTitle: string;
  listElements: PlaylistsSharingFeature[];
  ctaLabel?: string;
}

export const PlaylistsSharingPremiumPricingElement: React.FC<PlaylistsSharingPremiumPricingElementProps> = ({
  label,
  title,
  price,
  subtitle,
  outline,
  listTitle,
  listElements,
  ctaLabel
}) => {
  const router = useRouter();
  return (
    <div className={classNames('premium-pricing-element', { featured: label })}>
      <div className={classNames('premium-pricing-element-label', { isVisible: label })}>{label}</div>
      <h2 className="premium-pricing-element-title">{title}</h2>
      <h3 className="premium-pricing-element-price text-gradient">{price}</h3>
      <h4 className="premium-pricing-element-subtitle mb-5">{subtitle}</h4>
      <SignUpButton
        source="pricing"
        url={router.asPath}
        outline={outline}
        size="lg"
        className={classNames('mb-5', { 'btn-shadow-secondary': !outline })}
        block
        color="secondary"
      >
        {ctaLabel || <FormattedMessage id="sml.web.premium.buy" defaultMessage="Purchase now" />}
      </SignUpButton>
      <p className="premium-pricing-element-list-title">{listTitle}</p>
      <ul className="list-unstyled premium-pricing-element-list-container fa-ul">
        {listElements.map((el) => (
          // eslint-disable-next-line react/jsx-key
          <li>
            <span className="fa-li">
              <FontAwesomeIcon icon={el.icon} />
            </span>
            {el.label}
          </li>
        ))}
      </ul>
    </div>
  );
};
